export enum BillingsTaxiTaxiContributionBonusType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
}

export type BillingsTaxiTaxiContributionBonusFavorableDistance = {
  type: BillingsTaxiTaxiContributionBonusType.BONUS_FAVORABLE_DISTANCE;
  comment: string;
  distance: number | null;
  rate: number | null;
};

export type BillingsTaxiTaxiContributionBonusOther = {
  type: BillingsTaxiTaxiContributionBonusType.BONUS_OTHER;
  comment: string;
  amount: number | null;
  distance: null;
};

export type BillingsTaxiTaxiContributionBonusReal =
  | BillingsTaxiTaxiContributionBonusFavorableDistance
  | BillingsTaxiTaxiContributionBonusOther;

export type BillingsTaxiTaxiContributionBonusDummy = {
  type: null;
  comment: string;
  rate: number | null;
  amount: number | null;
  distance: number | null;
};

type BillingsTaxiTaxiContributionBonus =
  | BillingsTaxiTaxiContributionBonusReal
  | BillingsTaxiTaxiContributionBonusDummy;

export default BillingsTaxiTaxiContributionBonus;
